import React from 'react'
import ApolloClient from 'apollo-boost'
import { ApolloProvider } from 'react-apollo'
import useFirebase from './useFirebase'
import decode from 'jwt-decode'

function isTokenExpired(token) {
  function getTokenExpirationDate(token) {
    const decoded = decode(token)
    if (!decoded.exp) {
      return null
    }
    const date = new Date(0) // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp)
    return date
  }

  const date = getTokenExpirationDate(token)
  const offsetSeconds = 0
  if (date === null) {
    return false
  }
  return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000)
}

// Preconfigured HOC
const withApollo = BaseComponent => props => {
  const firebase = useFirebase()
  // Pass your GraphQL endpoint to uri
  const client = new ApolloClient({
    fetchOptions: {
      credentials: 'include'
    },
    request: async operation => {
      if (isTokenExpired(window.token)) {
        window.token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
      }
      operation.setContext({
        headers: {
          authorization: window.token
        }
      })
    }
  })

  return (
    <ApolloProvider client={client}>
      <BaseComponent {...props} />
    </ApolloProvider>
  )
}

export default withApollo
